// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"453":"fcf09d34","888":"3109f82c"}[chunkId] + ".css";
};